// This component has completely been modified for the transport histories screen design by Bearer Web Developer
import React from "react";
import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useAppState } from "../../states/app-state";
import TransportHistories from "./transportHistories";
import styles from './TransportHistoriesPopup.module.scss';
import { useThemeMode } from "../../states/contexts/theme"; // added by Bearer Web Developer
// useStyles removed by Bearer Web Developer

const TransportHistoriesPopup: React.FC = observer(() => { // properties removed by Bearer Web Developer

    // Transport Histories logic moved to Transport Histories component from here by Bearer Web Developer
    // added by Bearer Web Developer start
    const appState = useAppState();
    const { transportHistoryOpen: open, setTransportHistoryOpen } = appState?.transportHistory;
    const handleClose = () => { setTransportHistoryOpen(false); };
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md')); // 900px max width
    // added by Bearer Web Developer end
    const { theme: themeMode } = useThemeMode();
    // modified by Bearer Web Developer start
    return (
        <>
            {
                isMobile ?
                    <Dialog open={open} onClose={handleClose}
                        slotProps={{
                            paper: {
                                sx: {
                                    borderRadius: "10px", margin: "10px", minHeight: "calc(100% - 20px)", maxWidth: "100%", // minHeight is 100% - margin top and bottom
                                    backgroundColor: themeMode === "dark" ? 'var(--neutral-hsb-15, #262626)' : '#fff'
                                },
                                classes: { root: styles.paper_dialog, }
                            },
                        }}>
                        <TransportHistories />
                    </Dialog>
                    : 
                    <div className={styles.decktop} data-theme={themeMode}> {/* data-theme property added by Bearer Web Developer */}
                        <TransportHistories />
                    </div>
            }
        </>
    )
    // modified by Bearer Web Developer end
});
export default TransportHistoriesPopup;
// TransportHistory component Moved to a separate file in transportHistories file
// AddressLine component Moved to a separate file in transportHistories file


